import { Box, Button, Divider, Grid2, Typography } from "@mui/material";
import React, { useContext } from "react";
import { ReactComponent as ArrowIcon } from "Assets/Icons/Curriculum/ArrowIcon.svg";
import { ReactComponent as BackArrowIcon } from "Assets/Icons/Curriculum/BackArrowIcon.svg";
import PrimaryIcon from "Components/Common/PrimaryIcon";
import { useNavigate, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { DirectionContext } from "App";



const styles = (theme) => ({
  "& .moduleClassRow": {
    borderBottom: `1px solid ${theme.palette.border.blue}`,
    padding: "16px",
    "&:last-child": {
      borderBottom: "none",
    },
    "& .center": {
      display: "flex",
      alignItems: "center",
      flexDirection: "column",
    },
    "&:hover": {
      "& .dateTitle": {
        cursor: "pointer",
        color: theme.palette.primary.main,
      },
    },
  },
});

const ModulesClasses = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const { direction } = useContext(DirectionContext);

  const options = { day: '2-digit', month: 'short' };
  
  const { Modules, Translation } = useSelector((state) => ({
    Modules: state.Course.modules,
    Translation: state.Translation.translation?.Course || {},
  }));

  return (
    <>
      <Grid2 sx={styles}>
        <Typography color="secondary.light">
          {Translation?.ScheduleExpertMockInterview}
        </Typography>
        <Divider sx={{ margin: "15px 0px" }} />
        <Box display={"flex"} flexDirection={"column"} gap={"16px"}>
          {Modules[id]?.Sessions?.map((item, i) => {
            return (
              <Grid2
                container
                spacing={2}
                key={`module_class_${i}`}
                className="moduleClassRow"
              >
                <Grid2 size={2} 
                  onClick={() => navigate(`/session/${id}/${i}`)}
                  className="dateTitle">
                  <Typography>{`${Translation?.Day} ${item.Day}, ${new Date(item.StartDate).toLocaleString("default", options)}`}</Typography>
                </Grid2>
                <Grid2
                  // onClick={() => navigate(`/class/${i}`)}
                  onClick={() => navigate(`/session/${id}/${i}`)}
                  size={5}
                  className="dateTitle"
                >
                  {/* <Typography>Intro to Databases & Big Query Setup</Typography> */}
                  <Typography>{item?.ScheduleName}</Typography>
                </Grid2>
                <Grid2 size={1} className="center">
                  <Typography>{Translation?.PreRead}</Typography>
                  <Typography>-</Typography>
                </Grid2>
                <Grid2 size={1} className="center">
                  <Typography>{Translation?.Lecture}</Typography>
                  <Typography>0.0%</Typography>
                </Grid2>
                <Grid2 size={1} className="center">
                  <Typography>{Translation?.Assignment}</Typography>
                  <Typography color={item.NoOfQuestions === 0 ? "secondary" : item.SolvedQuestions == item.NoOfQuestions ? "success" : "error"}>{item.NoOfQuestions > 0 ? `${item.SolvedQuestions || 0}/${item.NoOfQuestions}` : "-"}</Typography>
                </Grid2>
                <Grid2 size={2} className="center">
                  <Box display={"flex"} alignItems={"center"} gap="32px">
                    <Box display={"flex"} flexDirection={"column"} alignItems={"center"}>
                      <Typography>{Translation?.AdditionalProblem}</Typography>
                      <Typography color={item.NoOfProblems === 0 ? "secondary" : item.SolvedProblems == item.NoOfProblems ? "success" : "error"}>{item.NoOfProblems > 0 ? `${item.SolvedProblems || 0}/${item.NoOfProblems}` : "-"}</Typography>
                    </Box>
                    <Button
                      sx={{
                        minWidth: "auto",
                        padding: "6px",
                        borderRadius: "4px",
                      }}
                      variant="outlined"
                      color="secondary"
                      // onClick={() => navigate(`/class/${i}`)}
                      onClick={() => navigate(`/session/${id}/${i}`)}
                    >
                      <PrimaryIcon
                        width="12px"
                        height="12px"
                        fill={false}
                        icon={direction === "rtl" ? BackArrowIcon : ArrowIcon}
                      />
                    </Button>
                  </Box>
                </Grid2>
              </Grid2>
            );
          })}
        </Box>
      </Grid2>
    </>
  );
};

export default ModulesClasses;
